import CareersPortalTable from "./table.vue";
Vue.component('careers-table', CareersPortalTable)

const careersPortalVueEnvironment = new Vue({
    delimiters: ['[%', '%]'],
    el: '.careersPortalVueEnvironment',
});
